import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import MembershipOverview from "../../elements/membership-overview";
import MembershipPayment from "../membership-payment";
import MembershipIncludedInPlan from "../membership-included-in-plan";
import MembershipNeedHelp from "../membership-need-help";
import OverviewPromoFinalizeOrder from "../../sections/overview-promo-finalize-order";
import Dropdown from "../../elements/dropdown";
import "./style.scss";
import { isEmptyObj } from "../../utils/siteUtils";

export default function MembershipDetailsSectionNew({ memberships, placeholder, setNextPaymentAndSummary }) {
  const [selectedMembership, setSelectedMembership] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const onSelectMembershipChange = async option => {
    if (!setNextPaymentAndSummary) return null;
    let currentObj = memberships.length > 0 ? await setNextPaymentAndSummary(memberships[option.code]) : null;
    setSelectedMembership(currentObj);
  };
  useEffect(() => {
    if (memberships?.length) {
      let options = [];
      memberships.forEach((membership, index) => {
        options.push({
          value: membership.car + " - " + membership.name,
          code: index.toString()
        });
      });
      setSelectedMembership(memberships[0]);
      setDropdownOptions({
        placeholder: placeholder,
        options: options,
        selectedOption: options[0]
      });
    }
  }, [memberships]);
  return (
    <div className="form-membership-section">
      <div className="form-membership-section-heading">
        <Heading
          {...{
            type: selectedMembership?.headingType,
            html: selectedMembership?.headingBody,
            typographyClass: "type-h3"
          }}
        />
      </div>
      <div className="form-membership-section-body">
        <BodyText html={selectedMembership?.body} />
      </div>
      {memberships.length > 1 && (
        <div className="form-membership-dropdown">
          <Dropdown
            {...{
              ...dropdownOptions,
              onChange: value => onSelectMembershipChange(value),
              className: "change-membership-dropdown"
              // onFocus: () => setCountryShowError(false),
            }}
          />
        </div>
      )}
      {selectedMembership?.membershipOverview && (
        <div className="form-membership-details">
          <MembershipOverview {...selectedMembership?.membershipOverview} />
        </div>
      )}
      {selectedMembership?.getStarted && (
        <div className="form-membership-details">
          <OverviewPromoFinalizeOrder {...selectedMembership?.getStarted} />
        </div>
      )}
      {selectedMembership?.paymentDetails && !isEmptyObj(selectedMembership?.paymentDetails) && (
        <div className="form-payment-details">
          <MembershipPayment paymentDetails={selectedMembership?.paymentDetails} />
        </div>
      )}
      {selectedMembership?.processStatus && (
        <div className="form-process-status">
          <div>
            <Heading type={selectedMembership?.processStatus.heading.type} html={selectedMembership?.processStatus.heading.html} />
          </div>
          <BodyText className={"process-status-body"} html={selectedMembership?.processStatus.body} />
        </div>
      )}
      {selectedMembership?.includedData && (
        <div className="form-included-in-plan">
          <MembershipIncludedInPlan includedData={selectedMembership?.includedData} />
        </div>
      )}
      {selectedMembership?.needHelp && (
        <div className="form-need-help">
          <MembershipNeedHelp needHelp={selectedMembership?.needHelp} />
        </div>
      )}
    </div>
  );
}

MembershipDetailsSectionNew.propTypes = {
  placeholder: PropTypes.string
  // memberships: PropTypes.shape({
  //   heading: PropTypes.shape({
  //     type: PropTypes.string,
  //     html: PropTypes.string,
  //     typographyClass: PropTypes.string
  //   }),
  //   body: PropTypes.string,
  //   membershipOverview: PropTypes.shape({
  //     heading: PropTypes.shape({
  //       type: PropTypes.string,
  //       html: PropTypes.string
  //     }),
  //     overview: PropTypes.shape({
  //       heading: PropTypes.string,
  //       subheading: PropTypes.string,
  //       body: PropTypes.string,
  //       MembershipFree: PropTypes.string,
  //       currency: PropTypes.string
  //     })
  //   }),
  //   paymentDetails: PropTypes.shape({
  //     nextPayment: PropTypes.shape({
  //       heading: PropTypes.shape({
  //         title: PropTypes.string,
  //         body: PropTypes.string
  //       }),
  //       items: PropTypes.array
  //     }),
  //     summary: PropTypes.shape({
  //       items: PropTypes.array
  //     }),
  //     link: PropTypes.object
  //   }),
  //   includedData: PropTypes.shape({
  //     heading: PropTypes.shape({
  //       title: PropTypes.string,
  //       type: PropTypes.string
  //     }),
  //     body: PropTypes.string,
  //     checks: PropTypes.array,
  //     list: PropTypes.shape({
  //       heading: PropTypes.shape({
  //         title: PropTypes.string,
  //         type: PropTypes.string
  //       }),
  //       links: PropTypes.array
  //     })
  //   }),
  //   needHelp: PropTypes.shape({
  //     heading: PropTypes.shape({
  //       title: PropTypes.string,
  //       body: PropTypes.string
  //     }),
  //     bodyApp: PropTypes.string,
  //     bodyContactUs: PropTypes.string,
  //     qrCode: PropTypes.object,
  //     button: PropTypes.object,
  //     openAppLink: PropTypes.object
  //   }),
  //   processStatus: PropTypes.shape({
  //     heading: PropTypes.shape({
  //       html: PropTypes.string,
  //       type: PropTypes.string
  //     }),
  //     body: PropTypes.string
  //   }),
  //   getStarted: PropTypes.shape({
  //     overviewHeading: PropTypes.object,
  //     overviewBody: PropTypes.object,
  //     button: PropTypes.object
  //   })
  // })
};
